import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./views/Home";
import Gober from "./views/Gober";
import Login from './views/Login';
import Registro from "./views/Registro";
import Departamento from "./views/Departamento";
import CrearCuenta from "./views/CrearCuenta";
import ActualizarDatos from "./views/Actualizardatos";
import { Toaster } from "react-hot-toast";
import BackButtonHandler from "./components/BackButtonHandler";
import Ruleta from "./views/Ruleta";
import Referidos from "./views/Referidos";
import PagoExitoso from "./views/PagoExitoso";
import PagoCancelado from "./views/PagoCancelado";
import Terminos from "./views/Terminos";
import Politicas from "./views/Politicas";
import Categorias from "./views/Categorias";
import { BottomSheetProvider } from "./context/BottomSheetContext";
import BottomSheet from "./components/BottomSheet";
import DestinoDetalle from './views/DestinoDetalle';
import Notificaciones from "./views/Notificaciones";
import Intereses from "./views/Intereses";
import Comercios from "./views/Comercios";
import Comercio from "./views/Comercio";
import { StoryProvider } from "./stories/NuevoStoryContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import Ofertas from "./views/Ofertas";
import Seguidos from "./views/Seguidos";
import Trending from "./views/Trending";
import Perfil from "./views/Perfil";
import { AuthProvider } from "./context/AuthContext";
import DemoAnimaciones from './views/DemoAnimaciones';
import ConnectionGuard from "./components/ConnectionGuard";
import Favoritos from "./views/Favoritos";
import Onboarding from "./components/Onboarding";
import Mapa from "./views/Mapa";
import { esIOSWebView } from "./utils/detectarIOS";
import Chat from "./views/Chat";
import Chats from "./views/Chats";
import Pagos from "./views/Pagos";
import Retiros from "./views/Retiros";
import Cuentas from "./views/Cuentas";
import Destinos from "./views/Destinos";
import Eventos from "./views/Eventos";
import { isAndroidWebView } from "./utils/device";
import AndroidPaddingWrapper from "./components/AndroidPaddingWrapper";
import Evento from "./views/Evento";
import MemoryGame from "./views/MemoryGame";
import JuegoRuleta from "./views/JuegoRuleta";
//import Emergencias from "./views/Emergencias";
import PixelTracker from "./PixelTracker";
import AnalyticsTracker from "./AnalyticsTracker"; 
import ClarityTracker from "./AnalyticsTracker"; 

const RootClassManager = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;

    if (location.pathname === "/ruleta") {
      root.classList.remove("centrado");
    } else {
      root.classList.add("centrado");
    }
  }, [location]);

  useEffect(() => {
 
    if (esIOSWebView()) {
      // Pedir las coordenadas directamente desde Flutter de forma periódica
      const interval = setInterval(async () => {
        const lat = await window.flutter_inappwebview?.callHandler("obtenerLat");
        const lng = await window.flutter_inappwebview?.callHandler("obtenerLng");
  
        if (lat && lng) {
          localStorage.setItem("userLat", lat);
          localStorage.setItem("userLng", lng);
        }
      }, 10000); // cada 10 segundos, similar al maximumAge
  
      return () => clearInterval(interval);
    }
  
    // Android / Web
    if ("geolocation" in navigator) {
      const watchId = navigator.geolocation.watchPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          localStorage.setItem("userLat", latitude);
          localStorage.setItem("userLng", longitude);
        },
        (error) => {},
        {
          enableHighAccuracy: true,
          maximumAge: 10000,
          timeout: 10000,
        }
      );
  
      return () => {
        navigator.geolocation.clearWatch(watchId);
      };
    }
  }, []);

  return children;
};

const splash = document.getElementById("splash-html");
if (splash) splash.style.display = "none";

const AppRoutes = () => (
  <ConnectionGuard>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
  <AuthProvider>
    <BrowserRouter>
      <PixelTracker />
      <AnalyticsTracker />
      <ClarityTracker />
      <AndroidPaddingWrapper />
      <StoryProvider>
        <BottomSheetProvider>
          <RootClassManager>
            <BackButtonHandler />
            <Toaster
              position="top-center"
              toastOptions={{
                duration: 4000,
                style: {
                  marginTop: isAndroidWebView() ? '30px' : 'env(safe-area-inset-top, 20px)',
                  background: "#000",
                  color: "#fff",
                  zIndex: 999999,
                  fontSize: "16px",
                },
              }}
            />            
            <Routes>
              <Route path="/" element={<Onboarding />} />
              <Route path="/home" element={<Home />} />
              <Route path="/gober" element={<Gober />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registro" element={<Registro />} />
              <Route path="/departamento" element={<Departamento />} />
              <Route path="/crear" element={<CrearCuenta />} />
              <Route path="/ruleta" element={<Ruleta />} />
              <Route path="/referidos" element={<Referidos />} />
              <Route path="/memoria" element={<MemoryGame />} />
              <Route path="/juegoruleta" element={<JuegoRuleta />} />
              <Route path="/retiros" element={<Retiros />} />
              <Route path="/cuentas" element={<Cuentas />} />
              <Route path="/animaciones" element={<DemoAnimaciones />} />
              <Route path="/categorias" element={<Categorias />} />
              <Route path="/ofertas" element={<Ofertas />} />
              <Route path="/trending" element={<Trending />} />
              <Route path="/intereses" element={<Intereses />} />
              <Route path="/destino/:id" element={<DestinoDetalle />} />
              <Route path="/terminos" element={<Terminos />} />
              <Route path="/politicas" element={<Politicas />} />
              <Route path="/comercio/:id_comercio/:id_sucursal" element={<Comercio />} />
              <Route path="/evento/:id_evento" element={<Evento />} />
              <Route path="/seguidos" element={<Seguidos />} />
              <Route path="/pagos" element={<Pagos />} />
              <Route path="/destinos" element={<Destinos />} />
              <Route path="/eventos" element={<Eventos />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/favoritos" element={<Favoritos />} />
              <Route path="/chats" element={<Chats />} />
              <Route path="/mapa" element={<Mapa />} />
              <Route path="/actualizardatos" element={<ActualizarDatos />} />
              <Route path="/comercios/:id_categoria" element={<Comercios />} />
              <Route path="/notificaciones" element={<Notificaciones />} />
              <Route path="/chat/:id_comercio/:id_sucursal" element={<Chat />} />
              <Route path="/pago-exitoso/:code" element={<PagoExitoso />} />
              <Route path="/pago-cancelado/:code" element={<PagoCancelado />} />
              <Route path="/perfil" element={<Perfil />} />
            </Routes>
            <BottomSheet/>
          </RootClassManager>
        </BottomSheetProvider>
      </StoryProvider>
    </BrowserRouter>
  </AuthProvider>
  </GoogleOAuthProvider>
  </ConnectionGuard>
);

export default AppRoutes;
